import Route from '@ember/routing/route';

export default class SiteExpiredPaymentLinkRoute extends Route {}
